import { useTranslation } from 'react-i18next';

import TutorialDialog from '@/components/TutorialDialog';
import VIDEO_TUTORIALS_MODAL_MODE from '@/enums/videoTutorialsModalMode';
import joinClassNames from '@/utils/functions/joinClassNames/joinClassNames';

import VideoTutorialsModalContent from './components/VideoTutorialsModalContent';
import styles from './styles.module.css';

import type { TutorielVideo, VideoTutorialsModalEntry } from '@/types/videoTutorials';

interface VideoTutorialsModalProps {
  isOpen: boolean;
  onClose: () => void;
  entry: VideoTutorialsModalEntry;
  partnerName: string;
  onPlay?: (tutorial: TutorielVideo) => void;
  onPartnerAccess: () => void;
  isPartnerAccessDisabled?: boolean;
}

const VideoTutorialsModal = ({
  isOpen,
  onClose,
  entry,
  partnerName,
  onPlay,
  onPartnerAccess,
  isPartnerAccessDisabled,
}: VideoTutorialsModalProps) => {
  const { t } = useTranslation();

  return (
    <TutorialDialog
      isOpen={isOpen}
      title={t('videoTutorials.modalTitle', { partnerName })}
      onClose={onClose}
      className={joinClassNames(
        styles.videoTutorialsModal,
        entry.mode === VIDEO_TUTORIALS_MODAL_MODE.SINGLE && styles.single
      )}
    >
      <VideoTutorialsModalContent
        entry={entry}
        partnerName={partnerName}
        onPlay={onPlay}
        onPartnerAccess={onPartnerAccess}
        isPartnerAccessDisabled={isPartnerAccessDisabled}
      />
    </TutorialDialog>
  );
};

export default VideoTutorialsModal;
